import { useContext } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { Lead, NotificationType, Place } from 'shared/topchef.types';
import placesApi from 'shared/topchef-api-places';

import { NotificationContext } from 'shared/NotificationContext'
import LeadContent from 'pages/shared/lead-content/LeadContent'
import { useErrorBoundary } from 'react-error-boundary'

export interface FollowedLeadDetailsFeesAcceptedProps {
  loggedInPlace: Place,
  currentLead: Lead,
}

const FollowedLeadDetailsFeesAccepted = (props: FollowedLeadDetailsFeesAcceptedProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();

  console.log("je suis dans le FollowedLeadDetailsFeesAccepted");

  const stopFollowing = async () => {
    try {
      await placesApi.unfollowLead(props.loggedInPlace.id, props.currentLead.id);
      navigate('/places/available-leads');
    } catch (error: any) {
      const newError = new Error(t('apiErrors.generic', { details: error.message }) as string);
      triggerNotification({type: NotificationType.error, message : newError.message});
      return showBoundary(newError);
    }
  };


  const backToFollowedLeads = async () => {
    navigate('/places/available-leads');
  };

  const signLead = async () => {
    try {
      await placesApi.signLead(props.loggedInPlace.id, props.currentLead.id);
      navigate('/places/leads/to-close');
    } catch (error: any) {
      const newError = new Error(t('apiErrors.generic', { details: error.message }) as string);
      triggerNotification({type: NotificationType.error, message : newError.message});
      return showBoundary(newError);
    }
  };

  const [confirmingSignature, setConfirmingSignature] = useState(false);

  return (
    <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">{t('common.addBrief')}</a></li>
        </ul>
      </div>
       
      <LeadContent lead={props.currentLead} />

      <div className="text-center">
        <div className="text-center btn-list">
          {props.currentLead.status === 'signed' &&
            <div>{t('followedLead.briefBeingSigned')}</div>
          } 
          {(props.currentLead.status === 'available' || props.currentLead.status === 'followed') &&
          <>
            <span className="position-instructions row mb-3">{t('followedLead.positionInstructions')}</span>
            <button className="btn btn-primary m-3 return-to-briefs-btn" onClick={backToFollowedLeads}>{t('followedLead.returnToBriefs')}</button> 
            {!confirmingSignature ? (
              <button className="btn btn-primary m-3" onClick={() => setConfirmingSignature(true)}>
                {t('followedLead.signed')}
              </button>
            ) : (
              <button className="btn btn-danger m-3" onClick={signLead}>
                {t('followedLead.confirmSignature')}
              </button>
            )}
            <div>
              <button className="btn m-3 btn-primary" onClick={stopFollowing}>{t('followedLead.leaveMySpot')}</button>
            </div>
          </>
          }
        </div>
      </div>
    </div>
  );

}


export default FollowedLeadDetailsFeesAccepted;
